export default "__VITE_ASSET__be0acd69__"